const inventoryUpdateFullcont = require('./inventoryUpdate-fullcont')
const inventoryUpdateMT       = require('./inventoryUpdate-fullcont-multitable')
const inventoryUpdateDialog   = require('./inventoryUpdate-dialog')
const inventoryUpdateSnack    = require('./inventoryUpdate-snack')
const inventoryUpdateQuickview = require('./inventoryUpdate-quickview')

export function start(detail){
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      fullcont:  { start: (detail)=>{  inventoryUpdateFullcont.start(detail)  }},
      multitable:{ start: (detail)=>{  inventoryUpdateMT.start(detail)        }},
      dialog:    { start: (detail)=>{  inventoryUpdateDialog.start(detail)    }},
      snack:     { start: (detail)=>{  inventoryUpdateSnack.start(detail)     }},
      quickview: { start: (detail)=>{  inventoryUpdateQuickview.start(detail) }},

}
